"use client";

import { useLayoutEffect, useState } from "react";

function resolveCursorPortalRoot(): HTMLElement {
	const fs = document.fullscreenElement;
	return fs instanceof HTMLElement ? fs : document.body;
}

/**
 * Portal host for cursor overlays: `document.body`, or the fullscreen element while native fullscreen
 * is active so cursors paint above fullscreen video.
 */
export function useCursorPortalRoot(): HTMLElement | null {
	const [root, setRoot] = useState<HTMLElement | null>(null);

	useLayoutEffect(() => {
		const sync = () => {
			setRoot(resolveCursorPortalRoot());
		};
		sync();
		document.addEventListener("fullscreenchange", sync);
		return () => document.removeEventListener("fullscreenchange", sync);
	}, []);

	return root;
}
